import { useContext } from 'react';
import { AddUndoableMutationContext } from "./AddUndoableMutationContext.js";
export var useAddUndoableMutation = function () {
    return useContext(AddUndoableMutationContext);
};
//# sourceMappingURL=useAddUndoableMutation.js.map